/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */

const AreaChart = () => {
	return (
		<svg width='24' height='24' viewBox='0 0 80 80'>
			<polygon fill='#fea58e' points='0,71.6 28.8,24.9 80,0 80,25.8 29.2,41 '></polygon>
			<polygon fill='#51d3d9' points='0,76.2 30.2,44.7 80,29.4 80,48 59,49.6 31,56.2 '></polygon>
			<polygon fill='#bda9ea' points='0,80 32,59.8 59.2,53.6 80,51.4 80,80 '></polygon>
		</svg>
	);
};

export default AreaChart;
